// import { BASE_PATH, REFRESH_TOKEN } from "@constants/PathConfig";
import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/dist/query";
import { BASE_URL } from "../constans/PathConfig";
// import LocalStorageService from "@utils/LocalStorageService";

import { QueryReturnValue } from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import { HTTPCode } from "./TypeResponse";
import LocalStorageService from "../utils/LocalStorageService";

type RefreshData = {
  code: number;
  data: {
    access_token: string;
  };
  message: string;
};

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL, //BASE_PATH
  prepareHeaders: async (headers) => {
    const token = LocalStorageService.getAccessToken();
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const FetchService: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = (await baseQuery(args, api, extraOptions)) as QueryReturnValue<
    any,
    FetchBaseQueryError,
    FetchBaseQueryMeta
  >;

  return result;
};
export default FetchService;
